/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ status: NonNullable<unknown> }} Error_Code_Already_OwnedInputs */

const en_error_code_already_owned = /** @type {(inputs: Error_Code_Already_OwnedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error Code: ${i?.status}. You already own this item. Please contact support in the app if you need further help.`)
};

const ar_error_code_already_owned = /** @type {(inputs: Error_Code_Already_OwnedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`كود الخطأ: ${i?.status}. أنت تملك هذا العنصر بالفعل. يرجى الاتصال بالدعم في التطبيق إذا كنت بحاجة إلى مزيد من المساعدة.`)
};

const de_error_code_already_owned = /** @type {(inputs: Error_Code_Already_OwnedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehlercode: ${i?.status}. Sie besitzen diesen Artikel bereits. Bitte kontaktieren Sie den Support in der App, wenn Sie weitere Hilfe benötigen.`)
};

const es_error_code_already_owned = /** @type {(inputs: Error_Code_Already_OwnedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Código de error: ${i?.status}. Ya tienes este artículo. Ponte en contacto con el servicio de asistencia de la app si necesitas más ayuda.`)
};

const fr_error_code_already_owned = /** @type {(inputs: Error_Code_Already_OwnedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Code d'erreur: ${i?.status}. Vous possédez déjà cet article. Contactez le support depuis l'application si vous avez besoin d'aide supplémentaire.`)
};

const it_error_code_already_owned = /** @type {(inputs: Error_Code_Already_OwnedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Codice Errore: ${i?.status}. Possiedi già questo elemento. Contatta il supporto nell'app se hai bisogno di ulteriore aiuto.`)
};

const ja_error_code_already_owned = /** @type {(inputs: Error_Code_Already_OwnedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`エラーコード：${i?.status}。このアイテムはすでに保有しています。ご不明な点がございましたら、アプリ内のサポートまでお問い合わせください。`)
};

const ko_error_code_already_owned = /** @type {(inputs: Error_Code_Already_OwnedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`오류 코드: ${i?.status}. 이미 소유 중인 아이템입니다. 추가 도움이 필요하면 앱에서 고객센터에 문의하세요.`)
};

const pt_br_error_code_already_owned = /** @type {(inputs: Error_Code_Already_OwnedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Código de erro: ${i?.status}. Você já possui esse item. Entre em contato com o suporte no aplicativo se precisar de ajuda.`)
};

const ru_error_code_already_owned = /** @type {(inputs: Error_Code_Already_OwnedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Код ошибки: ${i?.status}. У вас уже есть этот предмет. Свяжитесь с поддержкой в приложении, если вам нужна дополнительная помощь.`)
};

const th_error_code_already_owned = /** @type {(inputs: Error_Code_Already_OwnedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`รหัสข้อผิดพลาด: ${i?.status} คุณมีรายการนี้อยู่แล้ว โปรดติดต่อฝ่ายสนับสนุนในแอปหากคุณต้องการความช่วยเหลือเพิ่มเติม`)
};

const tr_error_code_already_owned = /** @type {(inputs: Error_Code_Already_OwnedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hata Kodu: ${i?.status}. Bu öğeye zaten sahipsin. Daha fazla yardıma ihtiyacın olursa lütfen uygulamada destek hattıyla iletişime geç.`)
};

const zh_cn_error_code_already_owned = /** @type {(inputs: Error_Code_Already_OwnedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`错误代码：${i?.status}，你已拥有此商品。如有其他问题，请在App 内联系客服。`)
};

const zh_tw_error_code_already_owned = /** @type {(inputs: Error_Code_Already_OwnedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`錯誤代碼：${i?.status}，目前已擁有此商品。若有更多問題，請回到 App 聯繫客服。`)
};

/**
* | output |
* | --- |
* | "Error Code: {status}. You already own this item. Please contact support in the app if you need further help." |
*
* @param {Error_Code_Already_OwnedInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const error_code_already_owned = /** @type {((inputs: Error_Code_Already_OwnedInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Code_Already_OwnedInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_code_already_owned(inputs)
	if (locale === "ar") return ar_error_code_already_owned(inputs)
	if (locale === "de") return de_error_code_already_owned(inputs)
	if (locale === "es") return es_error_code_already_owned(inputs)
	if (locale === "fr") return fr_error_code_already_owned(inputs)
	if (locale === "it") return it_error_code_already_owned(inputs)
	if (locale === "ja") return ja_error_code_already_owned(inputs)
	if (locale === "ko") return ko_error_code_already_owned(inputs)
	if (locale === "pt_br") return pt_br_error_code_already_owned(inputs)
	if (locale === "ru") return ru_error_code_already_owned(inputs)
	if (locale === "th") return th_error_code_already_owned(inputs)
	if (locale === "tr") return tr_error_code_already_owned(inputs)
	if (locale === "zh_cn") return zh_cn_error_code_already_owned(inputs)
	return zh_tw_error_code_already_owned(inputs)
});